'use client';
import { useEffect, useState, useCallback } from 'react';
import { useApiStore } from '@/context/global/stores/apiStore';
import { ContentShelf, HomeShelfResponse } from '@/context/global/types/homeShelf';
import mockJson from '@/features/home/mocks/homeShelf.mock.json';

export function useHomeShelves(language: 'th' | 'en' = 'th', useMock: boolean = false) {
  const [shelves, setShelves] = useState<ContentShelf[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { API } = useApiStore();

  const fetchShelves = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await API.Page.GetHomeShelf({ searchWord: '' });

      setShelves(response.data.responseObject.contentShelfs || []);
      // const mock = mockJson as HomeShelfResponse;
      // setShelves(mock.responseObject.contentShelfs);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      setError(errorMessage);

      console.error(err);
      throw error;
    } finally {
      setLoading(false);
    }
  }, [API, useMock]);

  useEffect(() => {
    fetchShelves();
  }, [fetchShelves]);

  return { shelves, loading, error, refetch: fetchShelves };
}
